import { jsxs as i, jsx as r } from "react/jsx-runtime";
import "react";
import { determineIfShowIsOnNow as o } from "../../../utils/date-helpers.js";
import { classes as s, convert12to24 as e } from "../../../utils/helpers.js";
import { AirDateFormatter as n } from "../../AirDateFormatter/AirDateFormatter.js";
function f({ scheduleItem: t, styles: a }) {
  return /* @__PURE__ */ i("div", { className: s([a["schedule-list__airdate"], "schedule-list__airdate"]), children: [
    o(`${t.start_date_parse}T${e(t.start_time)}`, t.element_length) && /* @__PURE__ */ r("div", { className: "schedule-list__on-now", children: "On Now" }),
    /* @__PURE__ */ r(
      n,
      {
        airdateStr: `${t.start_date} ${e(t.start_time)}`,
        separatorType: "line-break"
      }
    )
  ] });
}
export {
  f as AirDateSegment,
  f as default
};
